<template>
  <div class="hotel-page">
    <!-- 主內容 -->
    <!-- 主圖片區 (輪播圖) -->
    <section id="hero" class="carousel-container">
      <div class="carousel">
        <div
          class="carousel-slide"
          v-for="(image, index) in images"
          :key="index"
          :class="{ active: currentSlide === index }"
        >
          <img :src="image" alt="輪播圖圖片" />
        </div>
      </div>
      <!-- 底部選擇按鈕 -->
      <div class="carousel-indicators">
        <button
          v-for="(image, index) in images"
          :key="index"
          @click="goToSlide(index)"
          :class="{ active: currentSlide === index }"
        ></button>
      </div>
    </section>
    <main>
      <section class="room-title">
        <h3>泉韻居</h3>
        <h2>Quan Yun Ju</h2>
      </section>
      <!-- 房型介紹 -->
      <section class="room-row">
        <!-- 房型介紹 -->
        <div class="room-column">
          <h3>湯屋介紹</h3>
          <p>
            開闊的室內溫泉池，恣意遠眺自然景色，充份享受獨特的白磺泉療癒，讓每位造訪的貴客皆可獲得全然的放鬆。
            <br />※ 各湯屋格局不盡相同，圖片僅供參考，依實際為主
          </p>
        </div>

        <!-- 詳細資訊 -->
        <div class="room-column">
          <h3>詳細資訊</h3>
          <p>可容納人數：4 人</p>
          <p>湯屋坪數：15 坪（50 sq.m.）</p>

          <p>功效：消除疲勞、養顏美容、幫助神經、肌肉放鬆</p>
        </div>

        <!-- 定價 -->
        <div class="room-column">
          <h3>定價</h3>
          <p>NT$2,800 元</p>
          <button class="reserve-btn" @click="navigateToBooking">立即預定</button>
        </div>
      </section>

      <!-- 衛浴設備 -->
      <section class="room-facilities">
        <h3>衛浴設備</h3>
        <ul>
          <li><i class="fa-solid fa-hot-tub-person"></i> 溫泉</li>
          <li><i class="fa-solid fa-pump-soap"></i> 沐浴用品</li>
          <li><i class="fa-solid fa-soap"></i> 洗臉皂</li>
        </ul>
      </section>

      <!-- 客房設施 -->
      <section class="room-facilities">
        <h3>客房設施</h3>
        <ul>
          <li><i class="fas fa-bed"></i> 大床</li>
          <li><i class="fas fa-tv"></i> 液晶電視</li>
          <li><i class="fas fa-wifi"></i> 免費無線上網</li>
          <li><i class="fa-solid fa-martini-glass-citrus"></i> 迷你吧</li>
          <li><i class="fa-solid fa-wine-bottle"></i> 紅酒吧</li>
          <li><i class="fas fa-mug-hot"></i> 咖啡機</li>
          <li><i class="fas fa-water"></i> 瓶裝水</li>
          <li><i class="fa-solid fa-spa"></i> spa服務<br />(7:00 - 11:00)</li>
          <li>
            <i class="fa-solid fa-bell-concierge"></i>
            客房餐飲服務<br />(06:00-23:30)
          </li>
        </ul>
      </section>

      <!-- 訂房需知 -->
      <section class="booking-info">
        <h3>湯屋須知</h3>
        <ul>
          <li>入浴前應先徹底洗淨身體。</li>
          <li>
            患有心臟病、肺病、高血壓、糖尿病及其他循環系統障礙等慢性疾病者，應依照醫師指示入浴。
          </li>
          <li>入浴前後應適量補充水分。</li>
          <li>入浴應依序足浴、半身浴、全身浴，浸泡高度不宜超過心臟。</li>
          <li>入浴後有任何不適，請即出浴並通知服務人員。</li>
          <li>長途跋涉、疲勞過度或劇烈運動後，宜稍作休息再入浴。</li>
          <li>患有傳染性疾病者禁止入浴。</li>
          <li>女性生理期間禁止入浴。</li>
          <li>禁止攜帶寵物入浴。</li>
          <li>孕婦、行動不便者、老人及兒童，應避免單獨一人入浴。</li>
          <li>酒醉、空腹及飽食後，不宜入浴。</li>
          <li>入浴時間一次不宜超過十五分鐘，總時間不宜超過一小時。</li>
          <li>出浴後不宜直接進入烤箱。</li>
        </ul>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: "RoomDetail",
  data() {
    return {
      currentSlide: 0, // 當前顯示的圖片索引
      images: [], // 存放所有的圖片路徑
      autoSlideInterval: null, // 自動播放的定時器
    };
  },
  methods: {

    goToBooking() {
    this.$router.push('/booking'); // 使用 Vue Router 導航到 /booking
  },

  navigateToBooking() {
      this.$router.push("/booking").catch(err => {
        if (err.name !== "NavigationDuplicated") {
          console.error(err); // 僅記錄非重複導航的錯誤
        }
      });
    },

    // 動態加載圖片
    loadImages() {
      const context = require.context(
        "@/assets/picture/RoomImage3",
        false,
        /\.(png|jpe?g|gif|svg)$/
      );
      this.images = context.keys().map((key) => context(key)); // 將圖片賦值給 images
    },
    // 切換到特定的幻燈片
    goToSlide(index) {
      this.currentSlide = index;
    },
    // 顯示下一張幻燈片
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.images.length;
    },
    // 啟動自動播放
    startAutoSlide() {
      this.autoSlideInterval = setInterval(() => {
        this.nextSlide();
      }, 3500); // 每 3.5 秒切換一次
    },
    // 停止自動播放
    stopAutoSlide() {
      if (this.autoSlideInterval) {
        clearInterval(this.autoSlideInterval);
        this.autoSlideInterval = null;
      }
    },
  },
  mounted() {
    this.loadImages(); // 加載圖片
    this.startAutoSlide(); // 啟動自動播放
  },
  beforeDestroy() {
    this.stopAutoSlide(); // 停止自動播放
  },
};
</script>

<style src="@/assets/css/roomdetail.css" scoped></style>
